import { ClaimSaveAdapter } from '../../../adapter';

export default async function ClaimSaveUseCase(event) {

    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcc.dev.bpimsapps.com');
    const isUAT = url.includes('hcc.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionclaims.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/claim/save'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/claim/save'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/save`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/save`;
          
    // prepare data
    // const requestUrl = 'https://partners-api.dev.bpimsapps.com/claim/save';

    const payload = {
        ...event
    };

    // handle request
    const result = await ClaimSaveAdapter(endpoint, JSON.stringify(payload));

    return result;
}
